define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';

	/**
	 * Image class
	 */
	return function (url, width, height) {
		var _url,
			_width,
			_height;

		if (Util.isValidURL(url, true)) {
			_url = url;
		} else {
			throw new Error('invalid image url: ' + url);
		}

		if (!isNaN(width) && width > 0) {
			_width = width;
		} else {
			throw new Error('invalid image width: ' + width);
		}

		if (!isNaN(height) && height > 0) {
			_height = height;
		} else {
			throw new Error('invalid image height: ' + height);
		}


		// public methods

		this.url = function () {
			return _url;
		};

		this.width = function () {
			return _width;
		};

		this.height = function () {
			return _height;
		};

		this.toObject = function () {
			return {
				url : _url,
				width : _width,
				height : _height
			};
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Image.js
// module id = 27
// module chunks = 3